import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { createHttpParams } from '~/infrastructure/http/params';
import { API_NAMES, ApiServiceBase } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class SiteShipToAddressService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.common);
  }

  getSiteShipToAddress(paramsObj?: any, screenSiteId?: number) {
    paramsObj = paramsObj || {};
    paramsObj.screenSiteId = screenSiteId;
    let params = createHttpParams(paramsObj);

    return this.client.post(this._url(`/getSiteShipToAddresses`), null, { params, observe: 'response' });
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/SiteShipToAddress${v}`);
  }
}
